import Vue from "vue";
import VueRouter from "vue-router";
import Homepage from "../views/homepage.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: Homepage
    }
];

let routerMode = process.env.BASE_URL.indexOf("razem-wygramy") > -1 ? 'history' : 'hash';

const router = new VueRouter({
    mode: routerMode,
    routes: routes
});

export default router;
